class PasswordModal extends DetailsModal {
  constructor() {
    super();

    // Attach click event to all close buttons inside the modal
    const closeButtons = this.querySelectorAll('.modal__close-button, .modal__toggle-close, [data-modal-close]');
    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });
    });

    // Close when clicking on the backdrop area outside the card
    const modalContent = this.querySelector('.password-modal__content');
    if (modalContent) {
      modalContent.addEventListener('click', (event) => {
        if (event.target === modalContent) {
          event.preventDefault();
          this.close();
        }
      });
    }

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
  }

  close(focusToggle = true) {
    super.close(focusToggle);
    if (this.detailsContainer) {
      this.detailsContainer.removeAttribute('open');
      this.detailsContainer.classList.remove('menu-opening');
    }
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('password-modal', PasswordModal);
